import type { StudentPendingActionsVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrievePendingActions = createApiThunk<StudentPendingActionsVM, void>(
  "student/studentRetrievePendingActions",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.hasPendingActions();
  },
);
